import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SectionHeader from "../Atomics/SectionHeader/SectionHeader";
import VideoCard from "../Atomics/VideoCard/VideoCard";
import ChannelCard from "../Atomics/ChannelCard/ChannelCard";

export default function VideoBlockWithTag({
  title,
  videosBasedOnCategory,
  categoryId,
  channelName,
  mine,
  channelId,
  tag,
  tagId,
  location,
  more = 5,
  xs = 2,
  sm = 2,
  md = 6,
  lg = 8,
  xl = 12,
  type,
}) {
  // State to track the current breakpoint
  const [breakpoint, setBreakpoint] = useState("xl");

  // Function to determine the current breakpoint
  const getBreakpoint = () => {
    const width = window.innerWidth;
    if (width < 576) return "xs"; // Extra small
    if (width < 768) return "sm"; // Small
    if (width < 992) return "md"; // Medium
    if (width < 1200) return "lg"; // Large
    return "xl"; // Extra large
  };

  // Update the breakpoint on window resize
  useEffect(() => {
    const handleResize = () => setBreakpoint(getBreakpoint());
    handleResize(); // Set the initial breakpoint
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize); // Cleanup listener
  }, []);

  // Determine the number of items to show based on the breakpoint
  const getVisibleItems = () => {
    switch (breakpoint) {
      case "xs":
        return xs; // Show 2 cards on extra-small screens
      case "sm":
        return sm; // Show 4 cards on small screens
      case "md":
        return md; // Show 6 cards on medium screens
      case "lg":
        return lg; // Show 8 cards on large screens
      case "xl":
      default:
        return xl; // Show 10 cards on extra-large screens
    }
  };

  const visibleItems = getVisibleItems(); // Get the number of visible items
  const visibleVideos = videosBasedOnCategory?.content_items?.slice(
    0,
    visibleItems
  ); // Slice the array

  return (
    <div
      id={channelName}
      className="video-block section-padding"
      style={{
        maxWidth: "100%",
      }}
    >
      <Row>
        {/* Section header */}
        <Col xs={12}>
          <SectionHeader
            heading={title}
            more={{
              status: videosBasedOnCategory?.content_items?.length > more,
              value: mine
                ? `/myVideos/${channelId}`
                : tag
                ? `/tag-videos/${tagId}`
                : categoryId
                ? `/videos/${categoryId}`
                : `/videos`,
            }}
          />
        </Col>
      </Row>

      {/* Videos grid */}
      <Row className="gx-3 gy-4">
        {visibleVideos?.length !== 0 &&
          visibleVideos?.map((item, index) => (
            <Col
              key={index}
              xs={12} // Full width on extra small screens
              sm={6} // 2 columns on small screens
              md={4} // 3 columns on medium screens
              lg={3} // 4 columns on large screens
              xl={2} // 6 columns on extra-large screens
              className="mb-3 px-1"
            >
              {type === "channel" ? (
                <ChannelCard
                  total_video_count={item?.total_video_count}
                  imgSrc={item?.avatar}
                  views={item?.counted_view || 0}
                  videoViews={item?.total_video_views || 0}
                  channelName={item?.name}
                  subscriberCount={item?.subscribe_count || 0}
                  videosId={item?.name}
                  imgHref={`/single-channel/${item?.id}`}
                  channelHref={`/single-channel/${item?.id}`}
                  channelId={item?.id}
                  moreAdress={`/myVideos/${item?.id}`}
                />
              ) : (
                <VideoCard
                  imgSrc={item?.cover ? item?.cover : "img/v4.png"}
                  videoTitle={item.title}
                  videoCategory={item.categorys?.name}
                  views={item.counted_views}
                  timeAgo={item.published_date}
                  verified
                  channelName={item.channel?.name}
                  channelId={item.channel?.id}
                  imgHref={`/video-page/${item.id}/`}
                  iconHref={`/video-page/${item.id}/`}
                  videoTitleHref={`/video-page/${item.id}/`}
                  mine={mine}
                  videoId={item?.id}
                />
              )}
            </Col>
          ))}
      </Row>
    </div>
  );
}
